import React, {Component} from 'react'

export default class TotalBonus extends Component {
    constructor(props) {
        super(props)

        const listReferrals = [
            {
                name: 'Abraham Statersvili',
                balance: 102
            },
            {
                name: 'Nikolay Varnakov',
                balance: 51
            },
            {
                name: 'Jone Rokokosov',
                balance: 301
            },
            {
                name: 'Stepan Kormalovskiy',
                balance: 100
            },
            {
                name: 'Ivan Ivanov',
                balance: 20
            },
            {
                name: 'Anton Antonov',
                balance: 9
            },
            {
                name: 'Sergei Sergei',
                balance: 10
            },
            {
                name: 'Jone Rokokosov',
                balance: 1
            },
            {
                name: 'Jone Rokokosov',
                balance: 0
            }
        ];

        this.state = {
            listReferrals: listReferrals,
            allListReferrals: false,
            maxListReferrals: 4,
            allReferralsBalance: 0,
        }
    }

    sortListReferrals = () => {
        this.state.listReferrals.map(() => {
            this.state.listReferrals.sort((firstItem, secondItem) => {
                return secondItem.balance - firstItem.balance;
            })
        });
        this.calculationOfAmount();
    };

    calculationOfAmount = () => {
        let allReferralsBalance = 0;
        this.state.listReferrals.map((item) => {
            allReferralsBalance += item.balance;
        });
        this.state.allReferralsBalance = allReferralsBalance;
    }

    returnListReferrals = () => {
        return (
            <ul className="totalBonus-referrals">
                {this.state.listReferrals.map((item, index) => {
                    if (this.state.allListReferrals)
                        return (
                            <li key={index}>
                                <span>{item.name}</span>
                                <span>+ {item.balance}</span>
                                <span>CPT</span>
                            </li>
                        )
                    else if (index < this.state.maxListReferrals)
                        return (
                            <li key={index}>
                                <span>{item.name}</span>
                                <span>+ {item.balance}</span>
                                <span>CPT</span>
                            </li>
                        )
                })}
            </ul>
        )
    }

    switchOfList = (e) => {
        e.preventDefault();
        this.setState({allListReferrals: !this.state.allListReferrals})
    }

    render() {
        this.sortListReferrals();
        return (
            <div className="totalBonus">
                <div className="totalBonus-bonus">
                    <div className="totalBonus-bonus_header">
                        <p>Total bonus:</p>
                        <p className="footnote">in september, 2018</p>
                    </div>
                    <div className="totalBonus-bonus_balance">
                        + {this.state.allReferralsBalance} CPT
                    </div>
                </div>
                <div className="totalBonus-invite">
                    <input type="email" placeholder="E-mail"/>
                    <a href="/" className="btn btn-invite">Invite</a>
                </div>
                <div className="totalBonus-referrals">
                    {this.returnListReferrals()}
                    <div className="allLink">
                        <a href='#' onClick={this.switchOfList}>{this.state.allListReferrals ? "Close" : "See all"} {this.state.allListReferrals ? "" : this.state.listReferrals.length}</a>
                    </div>
                </div>
            </div>
        )
    }
}